import React from 'react';
import { BulletinMessagesVariable } from '../types';
import AccordionLevel from './AccordionLevel';
import MapMessageLine from './MapMessageLine';
import { useBulletinMessages } from '../../../../context/bulletin-messages';

export function hasFormErrorInEntry(
  entry: BulletinMessagesVariable,
  hasErrors?: Record<string, boolean>,
) {
  if (!hasErrors) {
    return false;
  }
  return Object.keys(hasErrors).some(
    k =>
      (k === entry.tree_key && hasErrors[k]) ||
      (hasErrors[k] && entry.maps.some(m => k === m.map_id.toString())),
  );
}

function EntryAccordion({
  entry,
  index,
}: {
  entry: BulletinMessagesVariable;
  index: number;
}) {
  const { hasErrors } = useBulletinMessages();
  const error = hasFormErrorInEntry(entry, hasErrors);
  return (
    <AccordionLevel
      title={entry.name}
      flagLabel="Message on entry"
      defaultValue={entry.content}
      index={index}
      type="entry"
      id={entry.tree_key}
      error={error}
    >
      {entry.maps.length > 0 ? (
        <p style={{ fontWeight: 'bold', paddingTop: 10 }}>Maps:</p>
      ) : null}
      {entry.maps.map((map, mapIndex) => (
        <div key={map.source}>
          {mapIndex > 0 ? <hr /> : null}
          <MapMessageLine key={map.source} map={map} />
        </div>
      ))}
    </AccordionLevel>
  );
}

export default EntryAccordion;
